/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Delivery_TypeInputs */

const en_orders_delivery_type = /** @type {(inputs: Orders_Delivery_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery Type`)
};

const es_orders_delivery_type = /** @type {(inputs: Orders_Delivery_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de entrega`)
};

/**
* | output |
* | --- |
* | "Delivery Type" |
*
* @param {Orders_Delivery_TypeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_delivery_type = /** @type {((inputs?: Orders_Delivery_TypeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Delivery_TypeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_delivery_type(inputs)
	return es_orders_delivery_type(inputs)
});